import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: {
    displayName: '',
    username: '',
    email: '',
    upiId: '',
  },
  loading: true,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
      state.loading = false;
    },
    clearUserInfo: (state) => {
      state.userInfo = {
        displayName: '',
        username: '',
        email: '',
        upiId: '',
      };
      state.loading = true;
    },
    setUserLoading: (state, action) => {
      state.loading = action.payload; // Set loading state based on the action payload
    },
  },
});

export const { setUserInfo, clearUserInfo, setUserLoading } = userSlice.actions;
export default userSlice.reducer;
